<template>
	<div class="layer-project" data-project-name="ket-renewal">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="nowrap">Korea Electric</span> <br /><span
							class="nowrap"
							>Terminal</span
						>
					</h1>
					<a href="http://www.ket.com" class="link" target="_blank"
						>www.ket.com</a
					>
				</div>
			</section>
			<!-- <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-01@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-02@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-04@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-06@m.jpg"></section> -->
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<div class="project-overview-tit"><strong>Overview</strong></div>
					<p class="project-overview-desc">
						반응형 웹으로 구성하여 다양한 디바이스에 대응하도록 제작되었고,
						글로벌 기업이미지에 맞게 <br class="break-t" />최신 디자인 트렌드를
						반영하여 구축하였습니다. <br />검색 기능을 강화하여 원하는 제품
						정보로 빠른 접근이 가능하도록 구성하였습니다.
					</p>
					<div class="diagram">
						<ul class="diagram01">
							<li class="item01">Vision</li>
							<li class="item02">Mission</li>
							<li class="item03">Philosophy</li>
						</ul>
						<ul class="diagram02">
							<li class="item01">
								Korea <br class="br-none" />
								Electric <br />
								Terminal
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section pc-main">
				<div class="inner-section">
					<strong class="project-subtit">PC Web</strong>
					<p class="project-desc">
						다양한 디바이스에 최적화 하기 위해 반응형 웹으로 홈페이지를
						리뉴얼하고, 변경된 제품군 정보를 반영하였습니다. <br />효율적인
						관리를 위해 메인을 관리자에 등록/수정/삭제 할 수 있게 하였고,
						<br class="break-m break-t" />제품별 카탈로그 등록 기능 및 검색
						기능을 강화 하였습니다.
					</p>
					<div class="main-page">
						<div class="img-wrap">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-main-01@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section pc-main-visual">
				<div class="inner-section">
					<div class="swiper-container">
						<ul class="swiper-wrapper">
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-main-list-01@m.jpg"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-main-list-02@m.jpg"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-main-list-03@m.jpg"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-main-list-04@m.jpg"
								/>
							</li>
						</ul>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section pc-sub">
				<div class="inner-section">
					<div class="img-wrap">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/ket-renewal/ket-renewal-pc-sub-page-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section mobile-main">
				<div class="inner-section">
					<strong class="project-subtit">Mobile Web</strong>
					<div class="swiper-container-wrap">
						<div class="swiper-container">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/ket-renewal/ket-renewal-mobile-main-01@m.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/ket-renewal/ket-renewal-mobile-main-02@m.png"
									/>
								</li>
							</ul>
						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section mobile-sub">
				<div class="inner-section">
					<div class="project-subdesc">
						<strong>PRODUCT <span class="nowrap">SUBMAIN</span></strong>
					</div>
					<div class="item-wrap">
						<div class="item">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-01@m.png"
							/>
						</div>
						<div class="item">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-02@m.png"
							/>
						</div>
						<div class="item">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-03@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section tablet-sub">
				<div class="inner-section">
					<strong class="project-subtit">Tablet Web</strong>
					<!-- <div class="swiper-container">
                    <ul class="swiper-wrapper">
                        <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-01@m.png"></li>
                        <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-02@m.png"></li>
                        <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-03@m.png"></li>
                        <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-04@m.png"></li>
                        <li class="swiper-slide"><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-05@m.png"></li>
                    </ul>
                    <div class="swiper-pagination"></div>
                </div> -->
					<div class="swiper-container">
						<ul class="swiper-wrapper">
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-01@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-02@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-03@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-04@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-05@m.png"
								/>
							</li>
						</ul>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section style">
				<div class="inner-section">
					<div class="font">
						<div class="font-01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-style-font-01@m.png"
							/>
						</div>
						<div class="font-02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket-renewal/ket-renewal-style-font-02@m.png"
							/>
						</div>
					</div>
					<div class="icon">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/ket-renewal/ket-renewal-style-icon-01@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">KET</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var isMainListSwiper = false;
		var isMobileMainSwiper = false;
		var isTabletSubSwiper = false;
		var mainListSwiper;
		var mobileMainSwiper;
		var tabletSubSwiper;
		var clear;

		mainListSwiperSet();
		mobileMainSwiperSet();
		tabletSubSwiperSet();

		$(window).on("resize", function () {
			resizeSet();
		});

		function resizeSet() {
			var w = $(window).outerWidth();
			if (w >= 712 && isMainListSwiper) {
				mainListSwiper.destroy();
				isMainListSwiper = false;
			} else {
				mainListSwiperSet();
			}

			if (w >= 712 && isMobileMainSwiper) {
				mobileMainSwiper.destroy();
				isMobileMainSwiper = false;
			} else {
				mobileMainSwiperSet();
			}

			if (w >= 712 && isTabletSubSwiper) {
				tabletSubSwiper.destroy();
				isTabletSubSwiper = false;
			} else {
				tabletSubSwiperSet();
			}
		}

		function mainListSwiperSet() {
			var w = $(window).outerWidth();

			if (isMainListSwiper | (w >= 712)) {
				return;
			}
			isMainListSwiper = true;
			mainListSwiper = new Swiper(".pc-main-visual .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				// centeredSlides: true,
				pagination: {
					el: ".pc-main-visual .swiper-pagination",
					clickable: true,
				},
			});
		}

		function mobileMainSwiperSet() {
			var w = $(window).outerWidth();

			if (isMobileMainSwiper | (w >= 712)) {
				return;
			}

			isMobileMainSwiper = true;
			mobileMainSwiper = new Swiper(".mobile-main .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				pagination: {
					el: ".mobile-main .swiper-pagination",
					clickable: true,
				},
			});
		}

		function tabletSubSwiperSet() {
			var w = $(window).outerWidth();

			if (isTabletSubSwiper | (w >= 712)) {
				//console.log("return");
				return;
			}
			//console.log("else");
			isTabletSubSwiper = true;
			tabletSubSwiper = new Swiper(".tablet-sub .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				pagination: {
					el: ".tablet-sub .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
.project-tit .nowrap {
	display: inline-block;
}
.project-client {
	background: url(/static/img/project-detail/ket-renewal/ci.png) 50% / auto
		41.5px no-repeat;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket-renewal/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket-renewal/bg-overview@t.jpg);
	}
	.project-tit br {
		display: none;
	}
	.project-tit .block {
		display: block;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket-renewal/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-client {
		background-size: auto 83px;
	}
}

/* project-overview [s] */
.project-overview {
	margin-top: 20px;
	background-color: #f1f1f1;
}
.project-overview .diagram {
	margin-top: 20px;
}
.project-overview .diagram01 {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	position: relative;
	width: 269px;
	margin: 0 auto;
}
.project-overview .diagram01::before {
	content: "";
	position: absolute;
	bottom: -20px;
	width: 1px;
	height: 41px;
	background-color: #2c2e32;
}
.project-overview .diagram01 > li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	border: 1px solid #2c2e32;
	border-radius: 50%;
}
.project-overview .diagram01 .item02 {
	margin-left: -7px;
}
.project-overview .diagram01 .item03 {
	margin-top: -25px;
}
.project-overview .diagram02 {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}
.project-overview .diagram02 > li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	background-color: #2c2e32;
	border-radius: 50%;
	color: #fff;
	text-align: center;
}

@media screen and (min-width: 712px) {
	.project-overview .diagram {
		display: flex;
		width: 633px;
		margin: 36px auto 0;
	}
	.project-overview .diagram01 {
		width: auto;
		margin-top: 0;
		padding-right: 119px;
	}
	.project-overview .diagram01::before {
		content: "";
		position: absolute;
		right: 16px;
		bottom: 50%;
		width: 87px;
		height: 1px;
		justify-content: start;
	}
	.project-overview .diagram01 > li {
		width: 132px;
		height: 132px;
	}
	.project-overview .diagram01 > li + li {
		margin-left: -7px;
	}
	.project-overview .diagram01 .item03 {
		margin-top: 0;
	}
	.project-overview .diagram02 {
		margin-top: 0;
	}
	.project-overview .diagram02 li {
		width: 132px;
		height: 132px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .diagram {
		width: 1240px;
		margin-top: 62px;
		padding-bottom: 20px;
	}
	.project-overview .diagram01 {
		padding-right: 277px;
	}
	.project-overview .diagram01::before {
		right: 62px;
		width: 162px;
	}
	.project-overview .diagram01 > li {
		width: 246px;
		height: 246px;
		font-size: 20px;
	}
	.project-overview .diagram01 > li + li {
		margin-left: -14px;
	}
	.project-overview .diagram01 .item02 {
		margin-left: -14px;
	}
	.project-overview .diagram02 .br-none {
		display: none;
	}
	.project-overview .diagram02 li {
		width: 246px;
		height: 246px;
		font-size: 28px;
	}
}
/* project-overview [e] */

/* pc-main [s] */
.pc-main {
	background-color: #2c2e32;
}
.pc-main .project-subtit,
.pc-main .project-desc {
	color: #fff;
}
.pc-main .img-wrap {
	width: 90.625%;
	margin: 21px auto 0;
	padding-bottom: 40px;
}

@media screen and (min-width: 712px) {
	.pc-main .img-wrap {
		width: 100%;
	}
}
@media screen and (min-width: 1280px) {
	.pc-main .project-subtit {
		padding-top: 60px;
	}
	.pc-main .main-page {
		padding-top: 30px;
	}
	.pc-main .img-wrap {
		padding-bottom: 80px;
	}
}
/* pc-main [e] */

/* pc-main-visual [s] */
.pc-main-visual {
	padding: 0;
	background-color: #eee;
}
.pc-main-visual .swiper-container {
	padding-bottom: 33px;
}
.pc-main-visual .swiper-slide img {
	width: 100%;
}
.pc-main-visual .swiper-pagination {
	height: 13px;
}

@media screen and (min-width: 712px) {
	.pc-main-visual .swiper-container {
		padding-bottom: 0;
	}
	.pc-main-visual .swiper-wrapper {
		flex-wrap: wrap;
	}
	.pc-main-visual .swiper-slide {
		flex: none;
		width: 50%;
	}
}
@media screen and (min-width: 1280px) {
	.pc-main-visual .inner-section {
		position: relative;
		height: 900px;
		padding: 0;
	}
	.pc-main-visual .swiper-container {
		position: absolute;
		top: 0;
		left: 50%;
		width: 1920px;
		margin-left: -960px;
	}
}
/* pc-main-visual [e] */

/* pc-sub [s] */
.pc-sub {
	padding: 28px 0 0;
	background-color: #eee;
}
.pc-sub .img-wrap img {
	width: 100%;
}

@media screen and (min-width: 712px) {
	.pc-sub {
		padding: 40px 0;
	}
}
@media screen and (min-width: 1280px) {
	.pc-sub {
		padding: 120px 0;
	}
	.pc-sub .inner-section {
		max-width: inherit;
		padding: 0;
	}
}
/* pc-sub [e] */

/* mobile-main [s] */
.mobile-main {
	padding-bottom: 0;
	background-color: #eee;
}
.mobile-main .swiper-container-wrap {
	position: relative;
	margin-top: -17px;
	margin-right: -15px;
	margin-left: -15px;
}
.mobile-main .swiper-container {
	padding-top: 17px;
	padding-bottom: 100px;
}
.mobile-main .swiper-slide {
	text-align: center;
}
.mobile-main .swiper-slide img {
	width: 39.53%;
	background-color: #000;
	box-shadow: 21px 24px 47px 0px rgba(0, 0, 0, 0.29);
	border-radius: 10% 12% / 5% 7%;
}
.mobile-main .swiper-pagination {
	bottom: 67px;
	left: 0;
	z-index: 1;
	width: 100%;
	height: 13px;
}

@media screen and (min-width: 712px) {
	.mobile-main .swiper-container {
		overflow: visible;
		margin-top: -54px;
		padding-top: 0;
	}
	.mobile-main .swiper-slide {
		flex: none;
		width: 22.38%;
	}
	.mobile-main .swiper-slide:nth-child(1) {
		margin-right: 3.95%;
		margin-left: 51.5%;
	}
	.mobile-main .swiper-slide:nth-child(2) {
		margin-top: -6.48%;
	}
	.mobile-main .swiper-slide img {
		width: 100%;
	}
	.mobile-main .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
}
/* mobile-main [e] */

/* mobile-sub [s] */
.mobile-sub {
	padding-top: 0;
	margin-bottom: -54% !important;
	background-color: #eee;
}
.mobile-sub .inner-section {
	margin: 0 -15px;
}
.mobile-sub .project-subdesc {
	font-size: 17.96875vw;
	color: #222;
	line-height: 1;
	opacity: 0.1;
	white-space: nowrap;
	letter-spacing: -2px;
}
.mobile-sub .project-subdesc .nowrap {
	display: block;
	margin-left: 17.5vw;
}
.mobile-sub .item-wrap {
	display: flex;
	position: relative;
	margin-top: -45%;
}
.mobile-sub .item-wrap .item {
	width: 35.15%;
}
.mobile-sub .item-wrap .item:nth-child(1) {
	width: 25.46%;
}
.mobile-sub .item-wrap .item:nth-child(2) {
	margin-top: 9%;
}
.mobile-sub .item-wrap .item:nth-child(3) {
	width: 25.15%;
	margin-top: 34%;
}
.mobile-sub .item-wrap .item + .item {
	margin-left: 7.5%;
}

@media screen and (min-width: 712px) {
	.mobile-sub .inner-section {
		margin: 0;
	}
	.mobile-sub .project-subdesc {
		font-size: 10.112vw;
		letter-spacing: 0;
	}
	.mobile-sub .project-subdesc .nowrap {
		display: block;
		margin-left: 27.38vw;
	}
	.mobile-sub .item-wrap {
		padding-bottom: 30%;
		padding-top: 13%;
	}
	.mobile-sub .item-wrap .item + .item {
		margin-left: 15.82%;
	}
	.mobile-sub .item-wrap .item:nth-child(1),
	.mobile-sub .item-wrap .item:nth-child(2),
	.mobile-sub .item-wrap .item:nth-child(3) {
		width: 22.94%;
	}
	.mobile-sub .item-wrap .item:nth-child(2) {
		margin-top: 9%;
	}
	.mobile-sub .item-wrap .item:nth-child(3) {
		margin-top: 29%;
	}
}
@media screen and (min-width: 1280px) {
	.mobile-sub .inner-section {
		margin: 0 auto;
	}
	.mobile-sub .project-subdesc {
		font-size: 162px;
	}
	.mobile-sub .project-subdesc .nowrap {
		display: block;
		margin-left: 330px;
	}
}
@media screen and (min-width: 1420px) {
	.mobile-sub {
		margin-bottom: -40% !important;
	}
}
/* mobile-sub [e] */

/* tablet-sub [s] */
.tablet-sub {
	background-color: #eee;
}
.tablet-sub .swiper-container {
	overflow: visible;
	margin: 0 -15px;
	padding-bottom: 33px;
}
.tablet-sub .swiper-slide {
	text-align: center;
}
.tablet-sub .swiper-slide img {
	width: 80%;
	background-color: #000;
	box-shadow: 14px 19px 34px 0px rgba(0, 0, 0, 0.29);
	border-radius: 4% 4% / 5% 6%;
}
.tablet-sub .swiper-pagination {
	height: 13px;
}

@media screen and (min-width: 712px) {
	/* .tablet-sub .swiper-slide img{box-shadow: 14px 19px 34px 0px rgba(0, 0, 0, 0.29);} */
	.tablet-sub .swiper-container {
		margin: 0 -40px;
		padding-bottom: 0;
	}
	.tablet-sub .swiper-wrapper {
		flex-wrap: wrap;
		margin-top: -54px;
	}
	.tablet-sub .swiper-slide {
		flex: none;
		height: auto;
		margin-right: 3.51%;
	}
	.tablet-sub .swiper-slide img {
		width: 100%;
	}
	.tablet-sub .swiper-slide:nth-child(1) {
		width: 35.95%;
		margin-left: 37.86%;
	}
	.tablet-sub .swiper-slide:nth-child(2) {
		width: 22.68%;
		margin-right: 0;
	}
	.tablet-sub .swiper-slide:nth-child(2) img {
		border-radius: 4% 0 0 4%;
	}
	.tablet-sub .swiper-slide:nth-child(3) {
		width: 14.74%;
	}
	.tablet-sub .swiper-slide:nth-child(3) img {
		border-radius: 0 4% 4% 0;
	}
	.tablet-sub .swiper-slide:nth-child(4) {
		width: 35.95%;
	}
	.tablet-sub .swiper-slide:nth-child(5) {
		width: 35.95%;
	}
	.tablet-sub .swiper-slide:nth-child(n + 3) {
		margin-top: 3.58%;
	}
	.tablet-sub .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.tablet-sub {
		padding: 120px 0;
	}
	.tablet-sub .swiper-container {
		position: relative;
		left: 50%;
		width: 1920px;
		margin: 0;
		margin-left: -960px;
	}
	.tablet-sub .swiper-slide {
		margin-right: 3.12%;
	}
	.tablet-sub .swiper-slide:nth-child(1) {
		width: 30.05%;
		margin-left: 41.1%;
	}
	.tablet-sub .swiper-slide:nth-child(2) {
		width: 25.72%;
	}
	.tablet-sub .swiper-slide:nth-child(3) {
		width: 16.19%;
	}
	.tablet-sub .swiper-slide:nth-child(4) {
		width: 30.05%;
	}
	.tablet-sub .swiper-slide:nth-child(5) {
		width: 30.05%;
	}
	.tablet-sub .swiper-slide:nth-child(n + 3) {
		margin-top: 3.12%;
	}
}
/* tablet-sub [e] */

/* style [s] */
.style {
	background-color: #2c2e32;
}
.style .font > div + div {
	margin-top: 40px;
}
.style .icon {
	margin-top: 40px;
}
.style .icon img {
	width: 100%;
}
.style .font-01 {
	width: 72.96%;
}
.style .font-02 {
	width: 65.78%;
}

@media screen and (min-width: 712px) {
	.style .font {
		display: flex;
	}
	.style .font > div {
		flex: 1;
	}
	.style .font > div + div {
		margin-top: 0;
	}
	.style .font-01 img {
		width: 73.89%;
	}
	.style .font-02 img {
		width: 66.61%;
	}
	.style .icon {
		padding-bottom: 0;
	}
}
@media screen and (min-width: 1280px) {
	.style {
		padding: 120px 0;
	}
	.style .icon {
		margin-top: 80px;
	}
	.style .font-01 img {
		width: 62.74%;
	}
	.style .font-02 img {
		width: 56.61%;
	}
}
/* style [e] */

.project-client {
	background-color: #f3f3f3;
}
</style>


// WEBPACK FOOTER //
// src/projects/ket-renewal.vue